/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { CreateCustomerDTO } from 'data/from-data/create-customer-form.data';
import { jobBoardAPI } from './base';
import { ContactPerson, JobClient } from 'data/users';

const customers = {
  getAll: '/customer',
  getCustomer: '/customer/:{id}',
  create: '/customer'
};

export const GET_CUSTOMERS_QUERY = async (): Promise<
  AxiosResponse<JobClient[]>
> => {
  return (await jobBoardAPI.get(customers.getAll)).data;
};

export const CREATE_CUSTOMER = async (
  formData: CreateCustomerDTO
): Promise<AxiosResponse<JobClient>> => {
  return jobBoardAPI.post(customers.create, formData);
};

export const GET_CUSTOMER = async (
  customerId: string
): Promise<AxiosResponse<JobClient>> => {
  const endpoint = customers.getCustomer.replace(':{id}', customerId);
  return (await jobBoardAPI.get(endpoint)).data;
};

export const UPDATE_CUSTOMER = async ({
  customerId,
  formData
}: {
  customerId?: string;
  formData?: CreateCustomerDTO;
}): Promise<AxiosResponse<JobClient>> => {
  const endpoint = `/customer/${customerId}`;

  return jobBoardAPI.patch(endpoint, formData);
};

export const DELETE_CUSTOMER = async (
  customerId: string
): Promise<AxiosResponse<void>> => {
  const endpoint = `/customer/${customerId}`;
  return jobBoardAPI.delete(endpoint);
};

export const GET_COMPANY_REPS = async (
  id: string
): Promise<AxiosResponse<ContactPerson[]>> =>
  (await jobBoardAPI.get(`customer/get-all-reps/${id}`)).data;
